const materialContent = {
  title: 'IR 자료실 매뉴얼',
  content: `
  <div class="page-title">[IR 자료실 관리]</div>

# [개요]
IR 자료실은 기업의 IR 관련 자료를 효율적으로 관리하고 제공하기 위한 도구입니다. 이 문서에서는 **자료실의 등록, 수정, 조회 등 전반적인 관리 방법**을 확인할 수 있습니다.

### 주요 기능 요약
| 기능 | 설명 | 권한 |
|------|------------------|------------|
| 자료 조회 | 등록된 IR 자료 목록 확인 및 검색 | 관리자 |
| 자료 등록 | 신규 IR 자료 등록 | 관리자 |
| 자료 수정 | 기존 IR 자료 정보 수정 | 관리자 |
| 자료 다운로드 | IR 자료 다운로드 | 관리자 |

# [조회]
등록된 IR 자료의 목록을 조회하고 관리할 수 있습니다.

### 📋 화면 구성 및 기능
| 영역 | 구성 | 주요 기능 |
|------|------|-----------|
| 검색 영역 | 검색 조건 및 필터 | • 언어별 필터링<br>• 검색어 기준 검색 |
| 목록 영역 | IR 자료 목록 테이블 | • 언어/제목/파일/다운로드/사용여부 확인<br>• 목록에서 직접 다운로드 가능 |
| 버튼 영역 | 등록 버튼 | • 신규 IR 자료 등록 |
| 버튼 영역 | 다운로드 버튼 | • 다운로드 파일 목록 확인 및 다운로드 |

![IR 자료 목록](/assets/images/guide/material/list.png)
![IR 자료 다운로드](/assets/images/guide/material/download.png)

# [등록/수정]
IR 자료를 신규 등록하거나 기존 자료의 상세 정보를 수정할 수 있습니다.

> ⚠️ **주의사항**
> - 파일은 여러 개 등록 가능합니다.
> - 저장 즉시 반영됩니다.

### 📋 화면 구성 및 기능
| 영역 | 입력 항목 | 설명 |
|------|-----------|------|
| 기본 설정 | • 언어<br>• 사용 여부 | • 노출 언어 선택<br>• 자료 사용 여부 설정 |
| 자료 정보 | • 제목<br>• 첨부파일 | • IR 자료 제목 입력<br>• 파일 업로드 (다중 선택 가능) |

![IR 자료 등록/수정](/assets/images/guide/material/edit.png)

    `,
};

export default materialContent;
